import * as mapbox from 'mapbox-gl';
import { Marker } from '../../types/Marker';
import { deg2rad, rad2deg } from '../../helpers';

export const getCenterPoint = (markers: Marker[]): mapbox.LngLatLike => {
    if (!markers || markers.length < 1) {
        // Coordinates to center map on the UK
        return {
            lat: 52.326302,
            lng: -1.849393,
        };
    }

    if (markers.length > 1) {
        let x = 0;
        let y = 0;
        let z = 0;

        markers.forEach((marker) => {
            const latLng = mapbox.LngLat.convert(marker.position);

            const lat = deg2rad(latLng.lat);
            const lng = deg2rad(latLng.lng);

            x += Math.cos(lat) * Math.cos(lng);
            y += Math.cos(lat) * Math.sin(lng);
            z += Math.sin(lat);
        });

        const avgX = x / markers.length;
        const avgY = y / markers.length;
        const avgZ = z / markers.length;

        const lng = Math.atan2(avgY, avgX);
        const hyp = Math.sqrt(avgX ** 2 + avgY ** 2);
        const lat = Math.atan2(avgZ, hyp);

        return {
            lat: rad2deg(lat),
            lng: rad2deg(lng),
        };
    } else {
        return markers[0].position;
    }
};
